<template>
    <section class="main">
        <div v-show="isLoading">
            <v-page-loading />
        </div>
        <div v-show="!isLoading">
            <v-page-header :title="getPageTile" />

            <div v-show="hasLoadingError">
                <div class="grid-container">
                    <p class="text-center">
                        {{ loadingError }}
                    </p>
                </div>
            </div>

            <div v-show="!hasLoadingError">
                <div class="grid-container">
                    <div class="grid-x">
                        <div class="cell medium-9 medium-offset-1 large-11 large-offset-0">
                            <div class="wrapper">
                                <v-action-buttons :items="getActionButtons" :isDisabled="locationFormDisabled" @actionClicked="onClickAction" />
                                <v-form-message type="error" id="form-error" :message="locationObjectError" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="success" id="form-success" :message="locationObjectSuccess" @onClickAction="onClickActivateDialogAction" />
                                <v-form-message type="default" id="form-activate" :message="locationObjectActivate" :autoCloseTimeout="0" :showActionButtons="true" @onClickAction="onClickActivateDialogAction" />

                                <div class="box">
                                    <v-navigation />

                                    <div class="form-group form-group--required">
                                        <label>{{ $t('customers.location_number') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.location_number }}
                                        </div>
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('customers.project_number') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.project_number }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-project-number">{{ $t('customers.project_number') }}</label>
                                        <input type="text" id="form-field-project-number" name="project_number" class="form-control" placeholder="0123456789" v-model="$v.locationObject.project_number" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('customers.company_name') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.company_name }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.locationObject.company_name.$error }">
                                        <label for="form-field-company-name">{{ $t('customers.company_name') }}</label>
                                        <input type="text" id="form-field-company-name" name="company_name" class="form-control" placeholder="Musterfirma" v-model="$v.locationObject.company_name.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.phone') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.phone }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.locationObject.phone.$error }">
                                        <label for="form-field-phone">{{ $t('form.phone') }}</label>
                                        <input type="tel" id="form-field-phone" name="phone" class="form-control" :placeholder="$t('form.phone.plc')" v-model="$v.locationObject.phone.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.address1') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.address1 }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.locationObject.address1.$error }">
                                        <label for="form-field-adress1">{{ $t('form.address1') }}</label>
                                        <input type="text" id="form-field-adress1" name="address1" class="form-control" :placeholder="$t('form.address1.plc')" v-model="$v.locationObject.address1.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.address2') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.address2 }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group">
                                        <label for="form-field-adress2">{{ $t('form.address2') }}</label>
                                        <input type="text" id="form-field-adress2" name="address2" class="form-control" :placeholder="$t('form.address2.plc')" v-model="locationObject.address2" />
                                    </div>
                                    <div class="grid-x grid-margin-x">
                                        <div class="cell large-6">
                                            <div v-if="isViewMethod" class="form-group">
                                                <label>{{ $t('form.zipcode') }}</label>
                                                <div class="form-control form-control--static">
                                                    {{ locationObject.zipcode }}
                                                </div>
                                            </div>
                                            <div v-else class="form-group form-group--required form-group--small" :class="{ 'form-group--error' : $v.locationObject.zipcode.$error }">
                                                <label for="form-field-zipcode">{{ $t('form.zipcode') }}</label>
                                                <input type="text" id="form-field-zipcode" name="zipcode" class="form-control" :class="{'loading-spinner--input' : geocodeLoading}" :placeholder="$t('form.zipcode.plc')" v-model="$v.locationObject.zipcode.$model" @keyup="onChangeZipcode" />
                                            </div>
                                            <div class="form-group" v-if="geocodeObject.zipcode.length > 1">
                                                <select name="zipcode_list" class="form-control form-control--select" @change="onSelectZipcode">
                                                    <option value="">{{ $t('form.zipcode.choose')}}</option>
                                                    <option v-for="item in geocodeObject.zipcode" :value="item.zipcode">
                                                        {{ item.zipcode }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                        <div class="cell large-6">
                                            <div v-if="isViewMethod" class="form-group">
                                                <label>{{ $t('form.city') }}</label>
                                                <div class="form-control form-control--static">
                                                    {{ locationObject.city }}
                                                </div>
                                            </div>
                                            <div v-else class="form-group form-group--required form-group--small" :class="{ 'form-group--error' : $v.locationObject.city.$error }">
                                                <label for="form-field-city">{{ $t('form.city') }}</label>
                                                <input type="text" id="form-field-city" name="city" class="form-control" :class="{'loading-spinner--input' : geocodeLoading}" :placeholder="$t('form.city.plc')" v-model="$v.locationObject.city.$model" @keyup="onChangeCity" />
                                            </div>
                                            <div class="form-group" v-if="geocodeObject.city.length > 1">
                                                <select name="city_list" class="form-control form-control--select" @change="onSelectCity">
                                                    <option value="">{{ $t('form.city.choose')}}</option>
                                                    <option v-for="item in geocodeObject.city" :value="item.city">
                                                        {{ item.city }}
                                                    </option>
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('customers.country') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ $helpers.countries[locationObject.country_code] }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.locationObject.country_code.$error }">
                                        <label for="form-field-country">{{ $t('customers.country') }}</label>
                                        <v-select-country id="form-field-country" v-model="$v.locationObject.country_code.$model" />
                                    </div>
                                    <div v-if="isViewMethod" class="form-group">
                                        <label>{{ $t('form.email') }}</label>
                                        <div class="form-control form-control--static">
                                            {{ locationObject.email }}
                                        </div>
                                    </div>
                                    <div v-else class="form-group form-group--required" :class="{ 'form-group--error' : $v.locationObject.email.$error }">
                                        <label for="form-field-email">{{ $t('form.email') }}</label>
                                        <input type="email" id="form-field-email" name="email" class="form-control" :placeholder="$t('form.email.plc')" v-model="$v.locationObject.email.$model" />
                                    </div>
                                    <template v-if="$store.getters.userIsAdmin">
                                        <div v-if="isViewMethod" class="form-group">
                                            <label>{{ $t('location.risk.risk_number') }}</label>
                                            <div class="form-control form-control--static">
                                                {{ locationObject.risk.risk_number }}
                                            </div>
                                        </div>
                                        <div v-else class="form-group form-group--required">
                                            <label for="form-field-email">{{ $t('location.risk.risk_number') }}</label>
                                            <input type="text" id="form-field-risk-number" name="risk-number" class="form-control" placeholder="X00000000" v-model="locationObject.risk.risk_number" />
                                        </div>
                                        <div v-if="locationObject.risk" class="form-group">
                                            <label>{{ $t('location.risk.decided_budget') }}</label>
                                            <div class="form-control form-control--static" :class="{'u-color--alert': !locationObject.risk.decided_budget}">
                                              <template v-if="locationObject.risk.decided_budget">
                                                {{ $helpers.formateCurrency(locationObject.risk.decided_budget)}}
                                              </template>
                                              <template v-else>
                                                {{$t('location.risk.decided_budget.not_exist')}}!
                                              </template>
                                            </div>
                                        </div>
                                        <div v-if="locationObject.risk.valid_from" class="form-group">
                                            <label>{{ $t('location.risk.valid_from') }}</label>
                                            <div class="form-control form-control--static" :class="{'u-color--alert': !locationObject.risk.is_valid}">
                                                {{ locationObject.risk.valid_from | moment('DD.MM.YYYY') }}
                                            </div>
                                        </div>
                                        <div v-if="locationObject.risk.valid_until" class="form-group">
                                            <label>{{ $t('location.risk.valid_until') }}</label>
                                            <div class="form-control form-control--static" :class="{'u-color--alert': !locationObject.risk.is_valid}">
                                                {{ locationObject.risk.valid_until | moment('DD.MM.YYYY')}}
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import PageHeader from './../../partials/PageHeader';
    import PageLoading from './../../partials/PageLoading';
    import ActionButtons from './../../partials/Foundation/ActionButtons';
    import Navigation from './../Navigation';
    import FormMessage from './../../partials/Forms/FormMessage';
    import { required, email } from 'vuelidate/lib/validators';

    import SelectCountry from './../../partials/Forms/SelectCountry';

    export default {
        data() {
            return {
                loading                 : false,
                loadingError            : null,
                customerObject          : {
                    id                      : 0
                },
                locationFormDisabled    : false,
                locationObjectError     : null,
                locationObjectSuccess   : null,
                locationObjectActivate  : null,
                locationObject          : {
                    id                      : 0,
                    customer_id             : this.$route.params.customer,
                    location_number         : 'n/a',
                    project_number          : '',
                    project_number_required : false,
                    company_name            : '',
                    email                   : '',
                    phone                   : '',
                    address1                : '',
                    address2                : '',
                    zipcode                 : '',
                    city                    : '',
                    country_code            : 'de',
                    active                  : 1,
                    risk: {
                        risk_number: '',
                        decided_budget: '',
                        valid_from: '',
                        valid_until: '',
                        is_valid: true
                    }
                },
                geocodeLoading          : false,
                geocodeObject           : {
                    zipcode                 : [],
                    city                    : []
                }
            };
        },
        components : {
            vPageHeader             : PageHeader,
            vPageLoading            : PageLoading,
            vActionButtons          : ActionButtons,
            vNavigation             : Navigation,
            vFormMessage            : FormMessage,
            vSelectCountry          : SelectCountry
        },
        computed : {
            isLoading : function () {
                return this.loading;
            },
            hasLoadingError : function () {
                return this.loadingError !== null;
            },
            isViewMethod : function () {
                return this.$route.meta.method === 'view';
            },
            isCreateMethod : function () {
                return this.$route.meta.method === 'create';
            },
            isUpdateMethod : function () {
                return this.$route.meta.method === 'update';
            },
            isDuplicateMethod : function () {
                return this.$route.meta.method === 'duplicate';
            },
            getPageTile : function () {
                if (this.customerObject.company_name) {
                    return this.customerObject.company_name;
                }

                return this.$t('location.' + this.$route.meta.method + '.title');
            },
            getActionButtons : function () {
                let buttons = [];

                if (this.isViewMethod) {
                    if (this.$store.getters.userHasPermission('location_update')) {
                        buttons.push({
                            action  : 'update',
                            router  : { name: 'customers-update-customer-location', params : { customer : this.$route.params.customer, location : this.$route.params.location } }
                        });
                    }
                }

                if (this.isCreateMethod) {
                    if (this.$store.getters.userHasPermission('location_create')) {
                        buttons.push({
                            action : 'save'
                        });
                    }
                }

                if (this.isUpdateMethod) {
                    if (this.$store.getters.userHasPermission('location_update')) {
                        buttons.push({
                            action : 'save'
                        });
                    }

                    if (this.$store.getters.userHasPermission('location_activate')) {
                        if (this.locationObject.active) {
                            buttons.push({
                             action : 'deactivate'
                            });
                        } else {
                            buttons.push({
                                action : 'activate'
                            });
                        }
                    }
                }

                buttons.push({
                    action  : 'cancel',
                    router  : { name : 'customers-view-customer-locations', params : { customer : this.$route.params.customer } }
                });

                return buttons;
            }
        },
        watch : {
            '$route' : {
                handler : function () {
                    this.onUpdateCustomer();
                },
                deep    : true
            }
        },
        created : function () {
            this.onUpdateCustomer();
        },
        validations : function () {
            return {
                locationObject : {
                    company_name : {
                        required
                    },
                    phone       : {
                        required
                    },
                    address1    : {
                        required
                    },
                    zipcode     : {
                        required
                    },
                    city        : {
                        required
                    },
                    country_code : {
                        required
                    },
                    email       : {
                        required,
                        email
                    }
                }
            }
        },
        methods : {
            onUpdateCustomer : function() {
                this.customerLoadingError = null;

                if (!this.$route.params.customer) {
                    this.onUpdateLocationObject();
                } else {
                    let promise = this.$api.clearParams()
                        .get('customers/' + this.$route.params.customer + '/get');

                    promise.then((response => {
                        this.customerObject = response.data.data;

                        this.onUpdateLocationObject();
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onUpdateLocationObject : function () {
                this.loadingError = null;

                if (!this.isCreateMethod) {
                    let promise = this.$api.clearParams()
                        .get('locations/' + this.$route.params.location + '/get');

                    promise.then((response => {
                        this.locationObject = Object.assign(this.locationObject, response.data.data);
                    }).bind(this)).catch((error => {
                        this.loadingError = error.response.data.message;
                    }).bind(this)).finally((() => {
                        this.loading = false;
                    }).bind(this));

                    this.loading = true;
                }
            },
            onSubmitLocationObject : function () {
                this.locationFormDisabled     = true;
                this.locationObjectError      = null;
                this.locationObjectSuccess    = null;

                this.$v.locationObject.$touch();

                if (this.$v.locationObject.$invalid) {
                    this.locationFormDisabled     = false;
                    this.locationObjectError      = this.$t('form.error_form');
                } else {
                    if (this.isCreateMethod) {
                        let promise = this.$api.clearParams()
                            .post('locations/create', this.locationObject);

                        promise.then((response => {
                            this.locationFormDisabled     = false;
                            this.locationObjectSuccess    = this.$t('location.create.success');

                            this.$router.push({ name : 'customers-update-customer-location', params : { customer : this.$route.params.customer, location : response.data.data.id } })
                        }).bind(this)).catch((error => {
                            this.locationFormDisabled     = false;
                            this.locationObjectError      = error.response.data.message;
                        }).bind(this));
                    } else if (this.isUpdateMethod) {
                        let promise = this.$api.clearParams()
                            .post('locations/' + this.$route.params.location + '/update', this.locationObject);

                        promise.then((response => {
                            this.locationFormDisabled     = false;
                            this.locationObjectSuccess    = this.$t('location.update.success');
                        }).bind(this)).catch((error => {
                            this.locationFormDisabled     = false;
                            this.locationObjectError      = error.response.data.message;
                        }).bind(this));
                    }
                }
            },
            onActivateLocationObject : function () {
                if (!this.locationObject.active) {
                    this.locationObjectActivate = this.$t('location.active.title');
                } else {
                    this.locationObjectActivate = this.$t('location.deactive.title');
                }
            },
            onActivateLocationObjectSubmit : function () {
                this.locationFormDisabled     = true;
                this.locationObjectError      = null;
                this.locationObjectSuccess    = null;
                this.locationObjectActivate   = null;

                let promise = this.$api.clearParams()
                    .post('locations/' + this.$route.params.location + '/activate', {
                        active : !this.locationObject.active
                    });

                promise.then((response => {
                    this.locationFormDisabled = false;

                    if (response.data.data.active) {
                        this.locationObjectSuccess = this.$t('location.active.success');
                    } else {
                        this.locationObjectSuccess = this.$t('location.deactive.success');
                    }

                    this.locationObject.active    = response.data.data.active;
                }).bind(this)).catch((error => {
                    this.locationFormDisabled     = false;
                    this.locationObjectError      = error.response.data.message;
                }).bind(this));
            },
            onClickAction : function (action) {
                this.locationObjectError      = null;
                this.locationObjectSuccess    = null;
                this.locationObjectActivate   = null;

                switch (action) {
                    case 'save':
                        this.onSubmitLocationObject();

                        break;
                    case 'activate':
                    case 'deactivate':
                        this.onActivateLocationObject();

                        break;
                }
            },
            onClickActivateDialogAction : function (id, action) {
                this.locationObjectError      = null;
                this.locationObjectSuccess    = null;
                this.locationObjectActivate   = null;

                switch (action) {
                    case 'yes':
                        if (id === 'form-activate') {
                            this.onActivateLocationObjectSubmit();
                        }

                        break;
                }
            },
            onChangeZipcode : _.debounce(function(event) {
                if (event.target.value !== '') {
                    this.getGeocodeResult(event.target.value, 'zipcode', 'city');
                }
            }, 500),
            onChangeCity : _.debounce(function(event) {
                if (event.target.value !== '') {
                    this.getGeocodeResult(event.target.value, 'city', 'zipcode');
                }
            }, 500),
            onSelectZipcode : function (event) {
                this.locationObject.zipcode = event.target.value;

                this.geocodeObject.zipcode = [];
            },
            onSelectCity : function (event) {
                this.locationObject.city = event.target.value;

                this.geocodeObject.city = [];
            },
            getGeocodeResult : function (value, type, target) {
                let promise = this.$geocoder.search(value, type);

                promise.then((response => {
                    let results = [];

                    response.data.data.forEach((function (row) {
                        results.push(row);
                    }).bind(this));

                    if (results.length === 1) {
                        this.locationObject[target] = results[0][target];
                    } else {
                        this.geocodeObject[target] = results;
                    }

                    this.geocodeObject[type]    = [];
                }).bind(this)).catch((error => {
                    this.geocodeObject[target]  = [];
                    this.geocodeObject[type]    = [];
                }).bind(this)).finally((() => {
                    this.geocodeLoading = false;
                }).bind(this));

                this.geocodeLoading = true;
            }
        }
    }
</script>